import { render, staticRenderFns } from "./ExternalProductNew.vue?vue&type=template&id=19f8e275&scoped=true&"
import script from "./ExternalProductNew.vue?vue&type=script&lang=js&"
export * from "./ExternalProductNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f8e275",
  null
  
)

export default component.exports